import { Injectable, Output, EventEmitter } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { map, takeWhile, filter } from 'rxjs/operators';
import { BreadcrumbService } from 'xng-breadcrumb';

@Injectable({
  providedIn: 'root'
})
export class CustomBreadcrumbService {
  private readonly title = 'Tekus';
  breadcrumb$: Subscription;

  private labelName: string;
  set setName(name: string) {
    this.labelName = name;
    this.changeLabel();
  }

  @Output() editedInput = new EventEmitter<Object>();

  constructor(
    private readonly translateService: TranslateService,
    private readonly breadcrumbService: BreadcrumbService,
    private readonly titleService: Title
  ) {
  }

  changeLabel() {

    if (this.breadcrumb$) {this.breadcrumb$.unsubscribe();}

    this.breadcrumb$ = this.breadcrumbService.breadcrumbs$
      .pipe(
        takeWhile(() => this.labelName && this.labelName.length > 0),
        filter((urlTree) => urlTree.length > 1),
        map((urlTree) => {
          let title = '';
          urlTree[urlTree.length - 1].label = this.labelName ?? urlTree[urlTree.length - 1].label;
         urlTree.forEach(label => {
            title = `${title} ${this.translateService.instant(label.label as string)} |`;
          });
          title = title.slice(0, -1);
          return title;
        })).subscribe((title) => this.titleService.setTitle(`${this.title} | ${title}`));

    this.breadcrumbService.breadcrumbs$
      .pipe(
        takeWhile(() => !this.labelName),
        filter((urlTree) => urlTree.length === 1),
        map((urlTree) => {
          let title = '';
          if (urlTree.length === 0) {
            title = this.translateService.instant(urlTree[0].label as string);
          } else {
            urlTree.forEach(label => {
              title = `${title} ${this.translateService.instant(label.label as string)} |`;
            });
            title = title.slice(0, -1);
          }

          return title;
        })).subscribe((title) => this.titleService.setTitle(`${this.title} | ${title}`));

  }
}
